import { ArrowForward } from '@mui/icons-material';
import { Box, Link as MuiLink, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

type GroupsFullDetailsButtonProps = {
  close: () => void;
  groupId: string;
};

const GroupsFullDetailsButton = ({
  close,
  groupId,
}: GroupsFullDetailsButtonProps) => {
  const { t } = useTranslation();

  return (
    <Box display={'flex'} justifyContent={'flex-end'} mb={2}>
      <MuiLink
        sx={{ display: 'flex', alignItems: 'flex-end' }}
        component={Link}
        to={`../${groupId}`}
        onClick={close}
        data-testid="GroupsFullDetails.Button"
      >
        <Typography variant="body2">
          {t('drawer.groupsDetailsDrawer.viewFullDetails')}
        </Typography>
        <ArrowForward sx={{ ml: 1 }} fontSize="small" />
      </MuiLink>
    </Box>
  );
};

export default GroupsFullDetailsButton;
